module.exports = __webpack_public_path__ + "static/img/printkup2.5df067d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/printkup2.png
// module id = pfFs
// module chunks = 0